import { createStore, applyMiddleware,compose,Action} from "redux";
import createSagaMiddleware from "redux-saga";
import { rootReducer } from "./rootReducer";
import rootSaga from "./rootSaga";
import { persistStore, persistReducer ,PersistConfig} from "redux-persist";
import storage from "redux-persist/lib/storage";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";

const composeEnhancers =
  (typeof window !== "undefined" &&
    (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;


const persistConfig = {
  key: `root`, // Placeholder, updated later
  storage,
  whitelist: ['persistedState'], // Explicitly persist cart
  blacklist: [],
  transforms: [], // Optional: add transforms if needed
  stateReconciler: autoMergeLevel2, // Add this for better state merging
  debug: true, 
};

// Create a persisted reducer
const persistedReducer = persistReducer< ReturnType<typeof rootReducer>, Action>(persistConfig, rootReducer);

// Saga Middle Init
const sagaMiddleware = createSagaMiddleware();

const Store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(sagaMiddleware))
);
// Middleware: Redux Saga
sagaMiddleware.run(rootSaga);

const Persistor = persistStore(Store);

export { Store, Persistor  };